/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query OpensourceQuery($uid: String!) {
    prismic {
      opensource(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_OpensourceBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_OpensourceBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Opensource = ({ data, location }) =>
  data.prismic.opensource ? (
    <MainLayout location={location} layout='opensource'>
    <Helmet>
      <title>{(data.prismic.opensource.title[0] && data.prismic.opensource.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.opensource.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.opensource.path : 'https://www.digitalocean.com' + data.prismic.opensource.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.opensource.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.opensource.title[0] ? data.prismic.opensource.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.opensource.description ? data.prismic.opensource.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.opensource.open_graph_image ? data.prismic.opensource.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.opensource.description ? data.prismic.opensource.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.opensource.title[0] ? data.prismic.opensource.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.opensource.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.opensource.path : 'https://www.digitalocean.com' + data.prismic.opensource.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.opensource.open_graph_image ? data.prismic.opensource.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.opensource.body} />
    </MainLayout>
  ) : null;

Opensource.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Opensource;
